import React, { useState, useEffect, useRef} from 'react';
import { auth } from "../config/firebase.config";
import { Search } from 'react-feather';
import '../css/style.css';
import SideMenuData from '../components/SideMenu/SideMenuData';
import SideMenu from '../components/SideMenu/SideMenu';
//import PerfectScrollbar from 'react-perfect-scrollbar';
import 'react-perfect-scrollbar/dist/css/styles.css';
import Logo from '../images/logoweb.png';
import UserImg from '../images/user.png';
import { useNavigate } from 'react-router-dom';
import { fetchUser } from '../config/UserDetailsPrimary';
import {handleLogout} from '../components/handleLogout';

import Loading from '../components/SideMenu/components/Loading';


const SidebarMenu = ({user}) => {

    const [activeMenu, setActiveMenu] = useState(null);

    
    const navigate = useNavigate();

    const [userDetails, setUserDetails] = useState(null);
  const [method, setMethod] = useState('insert'); // Assuming default method is 'insert'
  const [isLoading, setIsLoading] = useState(false);
  //console.log('udff :',user);
  
const user1 = JSON.parse(sessionStorage.getItem("user") || "{}");
console.log('email sored : ',user1);
 

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const data = await fetchUser(user); // Fetch user data
        if (data && data.length > 0) {
          setUserDetails(data[0]); // Set userDetails state
          setMethod('update')
          
        } else {
          console.log('No data found for id:', user);
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
    console.log('data found :', userDetails);
  }, [user]);

   
    const handleMainMenuClick = (mainIndex) => {
      setActiveMenu(mainIndex);
      //setActiveSubMenu(null);
    };
    

  
    const handleBeforeUnload = (logout) => {
        if (logout) {
            auth.signOut().then(() => {
                sessionStorage.removeItem("firebaseToken");
                window.location.href = "/";
            }).catch(error => {
                console.error("Logout error:", error);
            });
            sessionStorage.removeItem("firebaseToken");
        }
    };


    const handleSettingsClick = () => {
        navigate('/user-settings');
    };

    const [showProfileMenu, setShowProfileMenu] = useState(false);
    const profileMenuRef = useRef(null);

    const toggleProfileMenu = () => {
        setShowProfileMenu(!showProfileMenu);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (profileMenuRef.current && !profileMenuRef.current.contains(event.target)) {
                setShowProfileMenu(false);
            }
        };

        document.addEventListener('click', handleClickOutside);

        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [profileMenuRef]);
    

    
   
    //const userObject = { userData };
    
    //console.log('sss ',userObject);

    
   

    return (

      
            <div className="sidebar">
                <div className="sidebar-header">
                    <a href="/" className="sidebar-logo"><img width="150px" alt="logo" src={Logo} /></a>
                </div>

                <div className="sidebar-search">
                    <div className="search-body">
                        <Search />
                        <input type="text" className="form-control" placeholder="Search..." />
                    </div>
                </div>
              

                {!isLoading && userDetails && (

                <div className="sidebar-body">
               
                <ul className="nav-sidebar">
                    {SideMenuData.map((menuItem, mainIndex) => {
                        if (["Students", "Employees", "Accounts", "Student Reviews"].includes(menuItem.label) && userDetails && !['Admin', 'Super_user'].includes(userDetails.user_level)) {
                            return null; // Don't render "Accounts" section if user's role is not accountant
                            
                        }
                        return (
                            <SideMenu
                                key={mainIndex}
                                {...menuItem}
                                isActive={activeMenu === mainIndex}
                                onMainClick={() => handleMainMenuClick(mainIndex)}
                                onSubMenuClick={() => handleMainMenuClick(mainIndex)}
                            />
                        );
                    })}
                </ul>
                </div>
                )}
                
                
            
                {showProfileMenu && !isLoading && (
    <div className='submenu'>
       
           <a  onClick={handleSettingsClick}>Profile</a>
            <a href="#" onClick={handleLogout}>Logout</a>
        
    </div>
)}

<div>
                {isLoading ? (
         <Loading size={40} />
        ) : userDetails ? (
               

                <div className="sidebar-footer">
                    
                    <a href='#' className="avatar online">
     {userDetails && <img className="avatar-initial" src={userDetails.image ? `https://yesedacademy.com/database/${userDetails.image}` : UserImg} alt="user" /> }
     {!userDetails &&   <img className="avatar-initial" src={UserImg} alt="user" /> }
    </a>
                    <div className="avatar-body">
                        <div className="d-flex align-items-center justify-content-between">
                            <h6>{userDetails.name}</h6>
                            <div  className="profile-menu" ref={profileMenuRef}>
                                
                            <div onClick={toggleProfileMenu} className="footer-menu"><i className="ri-settings-4-line"></i></div>
                            </div>
                        </div>
                        <span>{userDetails.role}</span>
                    </div>
                </div>

            ) : (
   <div className="sidebar-footer">
                    
    <a href='#' className="avatar online">

<img className="avatar-initial" src={UserImg} alt="user" /> 
</a>
    <div className="avatar-body">
        <div className="d-flex align-items-center justify-content-between">
            <h6>Not found</h6>
            <div  className="profile-menu" ref={profileMenuRef}>
                
            <div onClick={toggleProfileMenu} className="footer-menu"><i className="ri-settings-4-line"></i></div>
            </div>
        </div>
        <span>Not found</span>
    </div>
</div>
  )} 

            </div>


            </div>

  

    );
};

export default SidebarMenu;